import { alphanumericRegex } from 'shell/constants/regex';
import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  filter: yup.object().shape({
    code: yup.string().nullable().matches(alphanumericRegex, 'Il campo non è valido'),
    description: yup.string().nullable().matches(alphanumericRegex, 'Il campo non è valido'),
    dateFrom: yup.date().nullable().typeError('Data non valida'),
    dateTo: yup
      .date()
      .nullable()
      .typeError('Data non valida')
      .when('dateFrom', (dateFrom, formvalidationSchema) =>
        dateFrom && dateFrom?.toString() !== 'Invalid Date'
          ? formvalidationSchema.min(
              dateFrom,
              'La data deve essere maggiore o uguale della data Dal'
            )
          : formvalidationSchema.nullable()
      ),
  }),
});
